import {Button, Container, Divider, Grid, Link, Stack, TextField, Typography} from "@mui/material";
import React, {useState} from "react";
import {useNavigate} from "react-router";
import {useUserLoginContext} from "../Contexts/UserContext";

function StripePortalPage() {
    const navigate = useNavigate();
    const setUser = useUserLoginContext();
    return (<Container maxWidth="md">
        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <Typography typography="h1" color="primary">Stripe portal</Typography>
                <Typography typography="subtitle" color="primary">...</Typography>
                <Divider sx={
                    (theme)=>({
                        paddingTop:theme.spacing(4)
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Button color="secondary" fullWidth={true} onClick={()=>{
                    setUser(null);
                    navigate('/')
                }} sx={(theme)=>({marginTop:theme.spacing(4)})} variant="contained" size="large">Return to index</Button>
            </Grid>
        </Grid>
    </Container>);
}
export default StripePortalPage;